'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoCodeWorking = function IoCodeWorking(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm10 20c0-1.2 0.6-1.9 1.9-1.9s1.9 0.7 1.9 1.9-0.7 1.9-1.9 1.9-1.9-0.6-1.9-1.9z m5.6 0c0-1.2 0.7-1.9 1.9-1.9s1.9 0.7 1.9 1.9-0.6 1.9-1.9 1.9-1.9-0.6-1.9-1.9z m5.7 0c0-1.2 0.6-1.9 1.8-1.9s1.9 0.7 1.9 1.9-0.6 1.9-1.9 1.9-1.8-0.6-1.8-1.9z m-10.7 10.6c-0.5 0-0.9-0.1-1.3-0.5l-8.8-8.8c-0.3-0.4-0.5-0.8-0.5-1.3s0.2-0.9 0.5-1.3l8.8-8.8c0.4-0.4 0.8-0.5 1.3-0.5s1 0.1 1.4 0.5 0.5 0.8 0.5 1.4-0.2 0.9-0.5 1.3l-7.5 7.4 7.5 7.4c0.3 0.4 0.5 0.8 0.5 1.4s-0.2 0.9-0.5 1.3-0.8 0.5-1.4 0.5z m13.8 0c-0.6 0-1-0.1-1.4-0.5s-0.5-0.8-0.5-1.3 0.2-1 0.5-1.4l7.5-7.4-7.5-7.4c-0.3-0.4-0.5-0.8-0.5-1.3s0.2-1 0.5-1.4 0.8-0.5 1.4-0.5 0.9 0.1 1.3 0.5l8.8 8.8c0.3 0.4 0.5 0.8 0.5 1.3s-0.2 0.9-0.5 1.3l-8.8 8.8c-0.4 0.4-0.8 0.5-1.3 0.5z' })
        )
    );
};

exports.default = IoCodeWorking;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/code-working.js
// module id = 2233
// module chunks = 0